import React from "react";
import settingIcon01 from "../../images/setting_icon_01.png";
import { Link, useLocation, useParams } from "react-router-dom";
import MainHeader from "../MainHeader";
import { useAppContext } from "../../utils/store";
import { getUserAuthorityName } from "../../utils/common";

export default function FireOnMenu() {
  const {
    store: { userName, userAuthority },
  } = useAppContext();
  const { id } = useParams();
  const location = useLocation();

  return (
    <div id="hamMenu">
      <div class="top-wrap">
        <MainHeader isOpenMenu={true} isShowTopPanel={true} isShowNotice={false} />
      </div>
      <div class="container">
        <div class="menu-list">
          <Link class="menu-item-wrap" to={`/fire-on/fire-alarm-sms-log/${id}/`} state={location.state}>
            <div class="le-wrap">
              <p class="menu-title">화재경보 SMS 알림 이력</p>
            </div>
            <i class="x-icon arrow-icon"></i>
          </Link>
          <Link class="menu-item-wrap" to={`/fire-on/fire-alarm-log/${id}/`} state={location.state} >
            <div class="le-wrap">
              <p class="menu-title">화재경보 발생/조치 보고서</p>
            </div>
            <i class="x-icon arrow-icon"></i>
          </Link>
          <Link class="menu-item-wrap" to="/fire-on/fire-alarm-statistics/" state={location.state}>
            <div class="le-wrap">
              <p class="menu-title">화재경보 통계</p>
            </div>
            <i class="x-icon arrow-icon"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}
